import './berkeleyhallclub/style';
import FormStructure from './berkeleyhallclub/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js